import { IdNovidade } from '../common-types';
import { GenericService } from '../generic-service';

export type CreateNovidade = {
  titulo: string;
  descricao: string;
  publicada?: boolean;
}

export type UpdateNovidade = Partial<CreateNovidade> & { id: string }

export type ResponseNovidade = {
  id: IdNovidade;
  titulo: string;
  descricao: string;
  publicada: boolean;
  /** Data de criação. */
  data: string;
  /** Quando passou a publicada (null em rascunho; ausente em servidor antigo). Base do "não lida". */
  dataPublicacao?: string | null;
}

export type ResponseNovidadeVisualizacao = {
  idConta: string | null;
  nomeConta: string | null;
  nomeUsuario: string;
  dataVisualizacao: string;
}

export class NovidadesService extends GenericService<CreateNovidade, UpdateNovidade, ResponseNovidade> {
  constructor() { super('novidades') }

  async getPublicadas(): Promise<ResponseNovidade[]> {
    return await this.f.get('/publicadas', undefined, { resolve404As: [], resolve404AsValue: true }) as ResponseNovidade[];
  }

  async registrarVisualizacoes(idsNovidades: string[]): Promise<void> {
    return await this.f.post('/visualizacoes', { idsNovidades }) as void;
  }

  async getVisualizacoes(idNovidade: string): Promise<ResponseNovidadeVisualizacao[]> {
    return await this.f.get(`/${idNovidade}/visualizacoes`, undefined, { resolve404As: [], resolve404AsValue: true }) as ResponseNovidadeVisualizacao[];
  }
}
